// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@tps/XDL/types";
import { css } from "styled-components";

export const fontConfig = {
    url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
    weight: {
        regular: 400,
        bold: 700,
    },
    xSmall: {
        size: 12,
        lineHeight: "17px",
    },
    headLine: {
        size: 20,
        lineHeight: "28px",
    },
    fontFamily: "'Open Sans', sans-serif",
};

export default {
    fontFamilyImportUrl: fontConfig.url,
    body: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        lineHeight: "26px",
        css: css`
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
        `,
    },
    p: {
        size: "16px",
        weight: fontConfig.weight.regular,
        lineHeight: "26px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h1: {
        size: "28px",
        weight: fontConfig.weight.bold,
        lineHeight: "36px",
        css: css`
            margin-bottom: 20px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h2: {
        size: "24px",
        weight: fontConfig.weight.bold,
        lineHeight: "32px",
        css: css`
            margin-bottom: 20px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h3: {
        size: "20px",
        weight: fontConfig.weight.bold,
        lineHeight: "28px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h4: {
        size: "18px",
        weight: fontConfig.weight.bold,
        lineHeight: "24px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h5: {
        size: "16px",
        weight: fontConfig.weight.bold,
        lineHeight: "22px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h6: {
        size: "14px",
        weight: fontConfig.weight.bold,
        lineHeight: "19px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            display: block;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "18px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "14px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        lineHeight: "22px",
    },
    headerTertiary: {
        forwardAs: "p",
        size: "14px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        lineHeight: "22px",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.main",
        transform: "uppercase",
        weight: fontConfig.weight.bold,
    },
} as xBaseTheme["typography"];
